<div class="container">
    @if (projectId) {
        <div class="contacts">
            @for (contact of contacts; track contact) {
                <div
                    class="item"
                    routerLink="/{{ Routenames.customers }}/{{ customerId }}/{{ Routenames.projects }}/{{
                        projectId
                    }}/{{ Routenames.contacts }}/{{ contact.id }}">
                    <app-contact-photo [contact]="contact" />
                    <div class="info">
                        <div>
                            {{ contact.name }}
                        </div>
                        <div>
                            <span> tel: {{ contact.phone }} </span>
                            <span class="d-none d-sm-inline"> | </span>
                            <span class="d-inline d-sm-none">
                                <br />
                            </span>
                            <span> email: {{ contact.email }} </span>
                        </div>
                    </div>
                    <div class="arrow"></div>
                </div>
            }
            @if (loading) {
                <div class="item">
                    <div class="row">
                        <div class="col-24 text-center">
                            <app-processbar></app-processbar>
                        </div>
                    </div>
                </div>
            } @else {
                @if (!contacts.length) {
                    <div class="item">
                        <div class="row cursor-default">
                            <div class="col-24 text-center">Er zijn nog geen contactpersonen beschikbaar</div>
                        </div>
                    </div>
                }
            }
            @if (Features.CustomersDetailContactsSave | hasFeature) {
                <div
                    class="item"
                    routerLink="/{{ Routenames.customers }}/{{ customerId }}/{{ Routenames.projects }}/{{
                        projectId
                    }}/{{ Routenames.contacts }}/{{ Routenames.newItem }}/{{ Routenames.edit }}">
                    <div class="row">
                        <div class="col-24 text-center"><i class="fas fa-plus"></i> Contactpersoon toevoegen</div>
                    </div>
                </div>
            }
        </div>
    }
    @if (!projectId) {
        <p class="pt-3 mb-1">
            <b>Voor welk project neem je contact op?</b>
        </p>

        <div class="contacts">
            @for (project of projects; track project) {
                <div
                    class="item"
                    routerLink="/{{ Routenames.customers }}/{{ project.customer_id }}/{{ Routenames.projects }}/{{
                        project.id
                    }}/{{ Routenames.contacts }}">
                    <div class="info">
                        <div>
                            {{ project.name }}
                        </div>
                    </div>
                    <div class="arrow"></div>
                </div>
            }
            @if (loading) {
                <div class="item">
                    <div class="row">
                        <div class="col-24 text-center">
                            <app-processbar></app-processbar>
                        </div>
                    </div>
                </div>
            } @else {
                @if (!projects.length) {
                    <div class="item">
                        <div class="row cursor-default">
                            <div class="col-24 text-center">Er zijn nog geen projecten beschikbaar</div>
                        </div>
                    </div>
                }
            }
            @if (Functionalities.CustomerProjectsParticipate | hasFunctionality) {
                <div
                    class="item"
                    routerLink="/{{ Routenames.customers }}/{{ customerId }}/{{ Routenames.projects }}/{{
                        projectId
                    }}/{{ Routenames.contacts }}/{{ Routenames.newItem }}/{{ Routenames.edit }}">
                    <div class="row">
                        <div class="col-24 text-center"><i class="fas fa-plus"></i> Contactpersoon toevoegen</div>
                    </div>
                </div>
            }
        </div>
    }
</div>
